import { useTranslation } from "react-i18next";
import React from 'react';
export default function PricingSummary({
  selectedPlan,
  selectedAddons,
  isYearly,
  onCheckout
}) {
  const {
    t
  } = useTranslation();
  if (!selectedPlan) return null;
  const isCustom = selectedPlan.type === 'Custom'; // Base plan price

  let planPrice = 0;

  if (!isCustom) {
    planPrice = isYearly ? parseFloat(selectedPlan.yearly_price) : parseFloat(selectedPlan.monthly_price);
  } // Add-on price sum


  const addonsTotal = selectedAddons.reduce((sum, addon) => sum + parseFloat(addon.monthly_price), 0);
  const addonsTotalYearly = addonsTotal * 12; // Calculate final totals

  const monthlyTotal = isYearly ? planPrice / 12 + addonsTotal : planPrice + addonsTotal;
  const yearlyTotal = isYearly ? planPrice + addonsTotalYearly : planPrice * 12 + addonsTotalYearly;

  const handleCheckout = () => {
    onCheckout({
      plan: selectedPlan,
      addons: selectedAddons,
      isYearly,
      totals: {
        monthly: monthlyTotal,
        yearly: yearlyTotal
      }
    });
  };

  return <div className="pricing-summary-container">
      <div className="pricing-summary-title">{t("Summary of Your Selection")}</div>
      
      {
      /* Plan Selection Row */
    }
      <div className="summary-row">
        <span style={{
        fontWeight: 'bold'
      }}>{selectedPlan.name}{t("Plan")}</span>
        <span>
          {isCustom ? 'Custom Pricing' : `$${planPrice.toFixed(2)}${isYearly ? '/yr' : '/mo'}`}
        </span>
      </div>

      {
      /* Add-ons List */
    }
      {selectedAddons.length > 0 && <div style={{
      margin: '15px 0'
    }}>
          <div style={{
        fontSize: '0.85rem',
        fontWeight: 'bold',
        color: '#778c77',
        marginBottom: 8
      }}>{t("Selected Add-ons:")}</div>
          {selectedAddons.map(addon => <div key={addon.id} className="summary-row addon-item">
              <span>{addon.name}</span>
              <span>
                ${parseFloat(addon.monthly_price).toFixed(2)}{t("/mo")}</span>
            </div>)}
        </div>}

      {
      /* Totals Row */
    }
      {!isCustom && <div className="summary-row total">
          <span>{t("Estimated Total (")}{isYearly ? 'Yearly' : 'Monthly'})</span>
          <span>
            ${(isYearly ? yearlyTotal : monthlyTotal).toFixed(2)}
          </span>
        </div>}

      {
      /* Custom messaging or checkout button */
    }
      {isCustom ? <button onClick={handleCheckout} className="checkout-btn">{t("Contact Sales")}</button> : <button onClick={handleCheckout} className="checkout-btn">{t("Proceed to Checkout")}</button>}
    </div>;
}